import { render, staticRenderFns } from "./SavingLoader.vue?vue&type=template&id=0a63ebbd&"
import script from "./SavingLoader.vue?vue&type=script&lang=js&"
export * from "./SavingLoader.vue?vue&type=script&lang=js&"
import style0 from "./SavingLoader.vue?vue&type=style&index=0&id=0a63ebbd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports